import md5 from 'md5';
// id manager for browser log with server log
const uuid = require('uuid/v1')();
const md5Ua = md5(navigator.userAgent);
// pre mean same browser env, for case user reload
const pre = md5Ua.slice(0, 8);
export const UNIQUE_ID = pre + uuid.slice(8, uuid.length);
